import { createContext } from 'react'

import type { PortalTheme } from './theme'

export interface ThemeContextValue {
  theme: PortalTheme
  /** Zmiana z UI: aplikuje motyw i zapisuje preferencję w profilu użytkownika. */
  setTheme: (theme: PortalTheme) => void
  /** Aplikacja motywu bez zapisu na serwer (sync z profilu). */
  setLocalTheme: (theme: PortalTheme) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
